@use "../../../../styles/Colors.scss" as Colors;
@use "../../../../styles/Constants.scss" as Constants;


.associated-subjob-data-container {
	display: flex;
	flex-direction: row;
	background-color: Colors.$col-blueBackground;
	padding-top: Constants.$val-spacing-s;
	padding-bottom: Constants.$val-spacing-xxs;
	padding-left: Constants.$val-spacing-s;
	padding-right: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-xs;
	margin-top: Constants.$val-spacing-xs;
	border: 1px solid Colors.$col-blueBorder;
	width: fit-content;
}

.associated-subjob-data-container-label {
	margin-left: Constants.$val-spacing-s;
}

.associated-subjob-data-container-job {
	text-transform: uppercase;
}